import index from './pages/index.vue'
import Header from './components/Header.vue'
import qualification_honor from './pages/qualification_honor.vue'
import garden_desc from './pages/garden_desc.vue'
import news from './pages/news.vue'
import gardenShow from './pages/garden_show.vue'
import graveShow from './pages/grave_show.vue'

import gardenAdvantage from './pages/garden_advantage.vue'
import serviceDesc from './pages/service_desc.vue'
import contactUs from './pages/contact_us.vue'
import graveGuide from './pages/grave_guide.vue'
import detailPage from './pages/detail_page.vue'


export default{
	routes:[
		{path:'/',name:"首页-鸿龍寨陵园", component: index},
		{path:'/index',name:"首页-鸿龍寨陵园", component: index},
		{path:'/qualification_honor',name:"荣誉资质-鸿龍寨陵园",component: qualification_honor},
		{path:'/garden_desc',name:"陵园介绍-鸿龍寨陵园",component: garden_desc},
		{path:'/garden_show',name:"陵园景观-鸿龍寨陵园",component: gardenShow},
		{path:'/grave_show',name:"墓型展示-鸿龍寨陵园",component: graveShow},
		{path:'/garden_advantage',name:"陵园优势-鸿龍寨陵园",component: gardenAdvantage},
		{path:'/service_desc',name:"服务介绍-鸿龍寨陵园",component: serviceDesc},
		{path:'/grave_guide',name:"购墓指南-鸿龍寨陵园",component: graveGuide},
		{path:'/news',name:"陵园资讯-鸿龍寨陵园",component: news},
		{path:'/contact_us',name:"联系我们-鸿龍寨陵园",component: contactUs},
		{path:'/detail_page',name:"详情页面-鸿龍寨陵园",component: detailPage}
	],
	mode:'history'
}


// WEBPACK FOOTER //
// ./src/router.config.js